import React from 'react';
import theme from './ResidentialUnitEdit.module.scss';
import { Trans } from '@lingui/react/macro';
import { PricingFieldValue, Order } from '@/types';
import Banner from '@/components/Banner';
import OrderListItem from '@/seller/components/orders/OrderListItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLevelUp } from '@fortawesome/pro-light-svg-icons';

type ExtendedPricingFieldValue = PricingFieldValue & {
    oldValue: number;
};

interface ResidentialUnitEditPricingFieldsOrdersProps {
    changedPricingFields: ExtendedPricingFieldValue[];
    orders: Order[];
}

const ResidentialUnitEditPricingFieldsOrders: React.FC<ResidentialUnitEditPricingFieldsOrdersProps> = ({
    changedPricingFields,
    orders,
}) => {
    const pricingFieldsNames = changedPricingFields.map((pf) => `'${pf.name}'`).join(', ');

    return (
        <>
            <p>
                <Trans>You are about to change the following pricing variables - {pricingFieldsNames}</Trans>
            </p>
            <Banner type="info">
                <Trans>
                    <strong>Please note</strong> below are the orders connected with pricing variables {pricingFieldsNames}.
                    Changing a variable value will mean that the associated orders will be canceled, and a new one with the
                    new quantity will be created.
                </Trans>
            </Banner>
            <div className={theme.subHeader}>Orders connected to the pricing variables</div>

            <div className={theme.listWrapper}>
                {orders?.map((o) => {
                    const pricingField = changedPricingFields.find((pf) => pf.pricingFieldId === o.pricingFieldId)!;
                    return (
                        <React.Fragment key={o.id}>
                            <OrderListItem onChange={() => null} order={o} readOnly />
                            <div className={theme.extraListInfo}>
                                <FontAwesomeIcon icon={faLevelUp} rotation={90} />
                                <Banner icon={null} type="info">
                                    <Trans>
                                        <strong>{pricingField.name}</strong> is changed from{' '}
                                        <strong>
                                            {pricingField.oldValue} to {pricingField.value}
                                        </strong>
                                    </Trans>
                                </Banner>
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        </>
    );
};

export default ResidentialUnitEditPricingFieldsOrders;
